module.exports = __webpack_public_path__ + "img/steward-img-1.1a7c74ef.png";